import React, { useCallback, useEffect, useState } from "react";
import {
  Switch,
  Route,
  useRouteMatch,
  Redirect,
  useHistory,
} from "react-router-dom";
import CommittedClubHome from "./CommittedClubHome";
import CommittedClubMonthView from "./CommittedClubMonthView";
import {
  BadgesService,
  BadgeTemplate,
  CompanyService,
} from "@pushpress/committed-club-typescript-sdk";
import { Loader } from "@pushpress/shared-components";
import CommittedClubSettings from "./CommittedClubSettings";
import Dashboard from "../../layouts/Dashboard";
import { Helmet } from "react-helmet";
import { configureSDK } from "./utils";

const CommittedClubRouter = () => {
  const [ready, setReady] = useState(false);
  const [badgeTemplate, setBadgeTemplate] = useState<BadgeTemplate>();

  const { path } = useRouteMatch("/committed-club");
  const history = useHistory();

  const verifyInstallation = useCallback(async () => {
    const result = await CompanyService.getCompanyStatus();
    return !result.error && result.data.company.installed;
  }, []);

  const fetchBadgeTemplate = useCallback(async () => {
    const response = await BadgesService.getBadgeTemplate();

    if (response.error) {
      setBadgeTemplate(undefined);
    } else {
      setBadgeTemplate(response.data);
    }

    setReady(true);
  }, []);

  useEffect(() => {
    const initialize = async () => {
      const installed = await verifyInstallation();
      if (installed) {
        fetchBadgeTemplate();
      } else {
        history.replace("/");
      }
    };

    configureSDK();
    initialize();
  }, [verifyInstallation, fetchBadgeTemplate, history]);

  if (!ready) {
    return (
      <>
        <Helmet>
          <title>Committed Club</title>
        </Helmet>
        <Dashboard scrollableContent disableContentPadding>
          <div className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-screen">
            <Loader />
          </div>
        </Dashboard>
      </>
    );
  }

  return (
    <Switch>
      <Route
        path={`${path}/settings`}
        render={() =>
          badgeTemplate ? (
            <CommittedClubSettings
              badgeTemplate={badgeTemplate}
              refetchBadgeTemplate={fetchBadgeTemplate}
            />
          ) : (
            <Redirect to={path} />
          )
        }
      />
      <Route
        path={`${path}/progress/:badgeUuid`}
        render={() =>
          badgeTemplate ? (
            <CommittedClubMonthView badgeTemplate={badgeTemplate} />
          ) : (
            <Redirect to={path} />
          )
        }
      />
      <Route
        exact
        path={path}
        render={() => (
          <CommittedClubHome
            badgeTemplate={badgeTemplate}
            refetchBadgeTemplate={fetchBadgeTemplate}
          />
        )}
      />
      <Redirect to={path} />
    </Switch>
  );
};

export default CommittedClubRouter;
